import React from 'react'
import { WaiterCallStatusWrap } from './index.styled'
import { useDispatch, useSelector } from 'react-redux'
import { selectTablesWaiterCallsNotifications } from '../../../redux/selector/restaurant'
import BellAnimation from './BellAnimation'
import MainIcon from '../../../img/svg/main'
import { setRestaurantShowNotificationsModal } from '../../../redux/action/restaurant'
import { CounterText, CounterWrap } from '../NotificationsModal/index.styled'
import NotificationModal from '../NotificationsModal'

const Bell = React.memo(() => {
	const waiterCalls = useSelector(selectTablesWaiterCallsNotifications)
	const notificationsLength = useSelector(state => state.restaurant.tablesNotificationsLength)
	const waiterCallsExist = waiterCalls?.length > 0
	const dispatch = useDispatch()

	const handleOpenNotificationsModal = () => {
		dispatch(setRestaurantShowNotificationsModal(true))
	}

	return (
		<>
			<WaiterCallStatusWrap onClick={handleOpenNotificationsModal}>
				{waiterCallsExist ? <BellAnimation /> : <MainIcon icon="bell" />}
				{notificationsLength > 0 && <CounterWrap data-testid="bell-counter" className="active">
					<CounterText>{notificationsLength}</CounterText>
				</CounterWrap>}
			</WaiterCallStatusWrap>

			<NotificationModal />
		</>
	)
})

Bell.displayName = 'Bell'
export default Bell
